// export const timeOffDurationOptions = [
//   {
//     label: 'timeOff:fullDay',
//     value: '1',
//   },
//   {
//     label: 'timeOff:halfDay',
//     value: '2',
//   },
//   {
//     label: 'timeOff:specificHours',
//     value: '3',
//   },
// ];
// export const payOptions = [
//   {
//     label: 'common:paid',
//     value: '1',
//   },
//   {
//     label: 'common:unpaid',
//     value: '0',
//   },
// ];
// export const dayHourOptions = [
//   {
//     label: 'common:days',
//     value: 'days',
//   },
//   {
//     label: 'common:hours',
//     value: 'hours',
//   },
// ];

export const timeOffDurationOptions = [
  {
    label: 'Full Day',
    value: '1',
  },
  {
    label: 'Half Day',
    value: '2',
  },
  {
    label: 'Specific Hours',
    value: '3',
  },
];

export const payOptions = [
  {
    label: 'Paid',
    value: '1',
  },
  {
    label: 'Unpaid',
    value: '0',
  },
];

export const dayHourOptions = [
  {
    label: 'days',
    value: 'days',
  },
  {
    label: 'hours',
    value: 'hours',
  },
];

export const accrualMethods = [
  { label: 'Hours', value: 'Hourly' },
  { label: 'Daily', value: 'Daily' },
  { label: 'Weekly', value: 'Weekly' },
  { label: 'Twice a month', value: 'Bi-Monthly' },
  { label: 'Monthly', value: 'Monthly' },
  { label: 'Quarterly', value: 'Quarterly' },
  { label: 'Twice a year', value: 'Semi-Annually' },
  { label: 'Yearly', value: 'Annually' },
  // { label: 'On anniversary', value: 'Anniversary' },
];
